module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAdCAMAAABhTZc9AAAAM1BMVEUAAAD///9Yd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3dYd3e9ejEjAAAAEHRSTlMAABEiM0RVZneImaq7zN3uf6QJ9gAAAORJREFUKM+d08tyxCAMRNHmIZAZbO7/f20WME6csbNI71SnKAQI6ZLS9+4xrFxNBsAe77VDB9qtJmiKO8Q7rVAVKtidNkgKBuVG8+CQQrnVNKBIoUH+1B2apAi4e75qgy5JzswrBknKZmbmMOI680wPkrZ3hc37MjOzss/6xDp3WPeUYftWT7pomG0sPbtbWMAfNQ5Iz2s7hH9qGuzPWsCf1f7UF9jS/qEGR5jqKmDxl/rSMif12PKpDrZ0bMfa/NiKpRDmc4Ygacqo2+Bn6pyN3HrvLUuqr9OOcvMXZNXd3d/z/AW98BKKc+qGTwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/groups/group_tl_icon_like.png
// module id = 758
// module chunks = 0